import React from 'react';

export default function AskReasonCard({ title, description, data }) {
  return (
    <div className='ui fluid card'>
      <div className='content'>
        <div className='header'>
          {title}
          <span className='ui text red bold'>*</span>
        </div>
        <p className='meta'>{description}</p>
        <div
          className='ui divider'
          style={{ margin: 0 }}
        ></div>
        <div className='ui form'>
          <div className='ui fluid textarea field'>
            <textarea
              required
              form='impact-form'
              name={data[0].field + '_reason'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
